module.exports = __webpack_public_path__ + "static/img/bg.e3b5be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 1